import { useCallback } from "react";

// Import service module for batch operations
const useImportService = (api) => {
  const batchImportRecords = useCallback(
    async (file, moduleName, mappings = {}, recipientEmail) => {
      try {
        const formData = new FormData();
        formData.append("file", file);
        const moduleDetails = {
          moduleName,
          mappings,
          recipientEmail,
        };
        formData.append(
          "moduleDetails",
          new Blob([JSON.stringify(moduleDetails)], {
            type: "application/json",
          })
        );
        const response = await api.post("/record/import", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        return {
          data: {
            id: response.data.id || `import_${Date.now()}`,
            message: "Import job started successfully",
          },
          status: response.status,
        };
      } catch (error) {
        console.error("Error importing records:", error);
        throw error;
      }
    },
    [api]
  );

  const checkImportStatus = useCallback(async (jobId, accountId) => {
    try {
      return {
        data: {
          id: jobId,
          status: "completed",
          objectMetaId: "",
          objectName: "",
          accountId: accountId,
          successCount: 0,
          failureCount: 0,
          totalRecords: 0,
          startTime: new Date().toISOString(),
          endTime: new Date().toISOString(),
        },
        status: 200,
      };
    } catch (error) {
      console.error("Error checking import status:", error);
      throw error;
    }
  }, []);

  return {
    batchImportRecords,
    checkImportStatus,
  };
};

export default useImportService;
